/*
 * function to format price to € or to return a '-' if it's not covered
 * @param {number} priceInCents
 * @returns Price as number or '-'
 */
export const formatPrice = (priceInCents: number) => {
  return priceInCents >= 0 ? `${(priceInCents / 100).toFixed(2)} €` : '-';
};
